import React from 'react';

export const MACHINE_MENU_POPOVER_WIDTH = 235;

export const machineMenuContainerStyle: React.CSSProperties = {
  position: 'fixed',
  width: MACHINE_MENU_POPOVER_WIDTH,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: 12.162,
  padding: '20px 14.595px',
  borderRadius: 30,
  borderTop: '1.216px solid rgba(255, 255, 255, 0.15)',
  borderRight: '0.608px solid rgba(255, 255, 255, 0.15)',
  borderBottom: '0.608px solid rgba(255, 255, 255, 0.15)',
  borderLeft: '1.216px solid rgba(255, 255, 255, 0.15)',
  background: 'rgba(45, 50, 60, 0.82)',
  backdropFilter: 'blur(60.81081008911133px)',
  WebkitBackdropFilter: 'blur(60.81081008911133px)',
  boxShadow: '2px 4px 20px 0 rgba(0, 0, 0, 0.25)',
  zIndex: 20001,
};

export const machineMenuBackdropStyle: React.CSSProperties = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: 'rgba(0, 0, 0, 0.32)',
  zIndex: 20000,
};

export const machineMenuItemStyle: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: 10,
  width: '100%',
  padding: 0,
  background: 'transparent',
  border: 'none',
  color: '#ffffff',
  fontSize: 16,
  fontFamily: 'inherit',
  textAlign: 'left',
  cursor: 'pointer',
};

export const machineMenuDividerStyle: React.CSSProperties = {
  alignSelf: 'stretch',
  height: 1,
  background: 'rgba(255, 255, 255, 0.3)',
  border: 'none',
  margin: 0,
};

export const machineMenuFilterItemStyle: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: 10,
  width: '100%',
  padding: 0,
  background: 'transparent',
  border: 'none',
  color: '#ffffff',
  fontFamily: 'Heebo, sans-serif',
  fontSize: 18,
  fontWeight: 400,
  letterSpacing: '-0.36px',
  textAlign: 'left',
  cursor: 'pointer',
};

export const machineMenuIconSlotStyle: React.CSSProperties = {
  width: 20,
  height: 20,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
};
